// src/features/hospital/hospitalSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit"
import { HospitalBuhangcupSerializer } from "@/types/hospital"
import { fetchPublicHospitalInfo, fetchPublicBuhangcup } from "@core/api/hospitalApi"
import { HospitalSerializer } from "@/types/hospital"
import { getServerInfo, ServerInfoResponse } from "@core/api/deviceApi"

interface HospitalState {
  hospitalinfo: HospitalSerializer | null
  hospitalinfoLoading: boolean
  hospitalinfoError: string | null
  buhangcup: HospitalBuhangcupSerializer | null
  loading: boolean
  error: string | null
  // 서버 버전
  serverVersion: string | null
}

const initialState: HospitalState = {
  hospitalinfo: null,
  hospitalinfoLoading: false,
  hospitalinfoError: null,
  buhangcup: null,
  loading: false,
  error: null,
  serverVersion: null,
}

// 서버 버전 및 토큰 정보 조회 thunk
export const fetchServerInfo = createAsyncThunk<ServerInfoResponse, void, { rejectValue: string }>(
  "hospital/fetchServerInfo",
  async (_, { rejectWithValue }) => {
    try {
      return await getServerInfo()
    } catch (err: any) {
      return rejectWithValue(err.message || "서버 정보 조회 오류입니다.")
    }
  }
)

const hospitalSlice = createSlice({
  name: "hospital",
  initialState,
  reducers: {
    setBuhangcup(state, action: PayloadAction<HospitalBuhangcupSerializer | null>) {
      state.buhangcup = action.payload
    },
    clearBuhangcup(state) {
      state.buhangcup = null
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
  },
  extraReducers: builder => {
    builder
      // fetchPublicHospitalInfo 관련 처리
      .addCase(fetchPublicHospitalInfo.pending, state => {
        state.hospitalinfoLoading = true
        state.hospitalinfoError = null
      })
      .addCase(fetchPublicHospitalInfo.fulfilled, (state, action) => {
        state.hospitalinfoLoading = false
        state.hospitalinfo = action.payload
      })
      .addCase(fetchPublicHospitalInfo.rejected, (state, action) => {
        state.hospitalinfoLoading = false
        state.hospitalinfoError = (action.payload as string) || action.error.message || "알 수 없는 오류 발생"
        if (state.hospitalinfo) {
          state.hospitalinfo.hospitalContractReceived = null
          state.hospitalinfo.hospitalCmsFeeReceived = null
          state.hospitalinfo.hospitalCmsDigitalSignatureReceived = null
          state.hospitalinfo.hospitalCmsSmsReceived = null
        }
      })
      // fetchPublicBuhangcup 관련 처리
      .addCase(fetchPublicBuhangcup.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchPublicBuhangcup.fulfilled, (state, action) => {
        state.loading = false
        state.buhangcup = action.payload
      })
      .addCase(fetchPublicBuhangcup.rejected, (state, action) => {
        state.loading = false
        state.error = (action.payload as string) || action.error.message || "알 수 없는 오류 발생"
      })
      // fetchServerInfo 관련 처리
      .addCase(fetchServerInfo.fulfilled, (state, action) => {
        state.serverVersion = action.payload.serverVersion
        console.log("[ServerInfo] serverVersion:", action.payload.serverVersion)
      })
  },
})

export const { setBuhangcup, clearBuhangcup, setLoading, setError } = hospitalSlice.actions

export default hospitalSlice.reducer

